export default __webpack_public_path__ + "static/media/Group 11607.a64e8104.svg";